<template>
    <div id="file-upload">
        <div v-if="!isSpecial">
            <div :class="`file-align-${align}`">
                <h3>{{ fieldLabelFile }}</h3>
                <div>
                    <div :class="['upload-container', { 'error': showError && isRequired && files.length === 0 }]">
                        <input type="file" :id="`file-input-${fieldId}`" class="file-input" @change="handleFileUpload" multiple>
                        <label :for="`file-input-${fieldId}`" class="file-label">
                            <div class="upload-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                    <polyline points="7,10 12,15 17,10"/>
                                    <line x1="12" y1="15" x2="12" y2="3"/>
                                </svg>
                            </div>
                            <div class="upload-text">
                                <p class="upload-title">{{ altLabelOne }}</p>
                                <p class="upload-subtitle">{{ altLabelTwo }}</p>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
            <div class="file-list" v-if="files.length > 0">
                <div v-for="(file, index) in files" :key="index" class="file-item">
                    <div class="file-preview-container">
                    <img :src="file.preview" class="file-preview" />
                    </div>
                    <div class="file-info">
                    <span class="file-name">{{ file.name }}</span>
                        <span class="file-size">{{ formatFileSize(file.raw?.size) }}</span>
                    </div>
                    <button class="delete-button" @click="removeFile(index)" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M3 6h18"/>
                            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div v-if="isSpecial" class="special-upload" @click="triggerFileInput">
            <img src="../../../SpecialForm/assets/btnLeft.svg" style="width: 200px" class="nano-img">
            <div class="label-overlay">
                <label v-if="files.length === 0">{{ localFieldLabelFile }}</label>
                <label v-else>Yüklendi...</label>
            </div>
            <input type="file" ref="specialFileInput" class="file-input" @change="handleSpecialFileUpload"
                   style="display: none">
        </div>
    </div>
</template>
<script>
import { uploadAsset } from "../../api/assetUpload";
import axios from "axios";

export default {
    name: "FormFileUpload",
    props: {
        fieldLabelFile: String,
        align: String,
        altLabelOne: String,
        altLabelTwo: String,
        value: {
            type: [Array, Object],
            default: () => [],
        },
        siteId: {
            type: String,
            required: true,
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
        showError: {
            type: Boolean,
            default: false,
        },
        formId: {
            type: String,
            required: true,
        },
        order: {
            type: Number,
            required: true,
        },
        fieldId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            files: [],
            fileUrls: [],
            isSpecial: false,
            localFieldLabelFile: this.fieldLabelFile,
        };
    },
    watch: {
        fieldLabelFile(newVal) {
            this.localFieldLabelFile = newVal;
        },
    },
    methods: {
        formatFileSize(bytes) {
            if (!bytes) return '';
            const k = 1024;
            const sizes = ['B', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
        },
        triggerFileInput() {
            this.$refs.specialFileInput.click();
        },
        handleSpecialFileUpload(event) {
            const currentIndex = this.files.length;
            const newFiles = Array.from(event.target.files).map(file => ({
                name: file.name,
                preview: file.name.endsWith('.pdf') ? 'https://static.supsis.live/common/image/PDFICON.png' : URL.createObjectURL(file),
                raw: file,
                _id: null,
                asset: null,
                fieldId: this.fieldId
            }));

            this.files = [...this.files, ...newFiles];

            newFiles.forEach((file, index) => {
                this.uploadFile(file.raw, currentIndex + index);
            });
        },
        handleFileUpload(event) {
            const currentIndex = this.files.length;
            const newFiles = Array.from(event.target.files).map(file => ({
                name: file.name,
                preview: file.name.endsWith('.pdf') ? 'https://static.supsis.live/common/image/PDFICON.png' : URL.createObjectURL(file),
                raw: file,
                _id: null,
                asset: null,
                fieldId: this.fieldId
            }));

            this.files = [...this.files, ...newFiles];

            newFiles.forEach((file, index) => {
                this.uploadFile(file.raw, currentIndex + index);
            });
        },
        removeFile(index) {
            URL.revokeObjectURL(this.files[index].preview);
            this.fileUrls.splice(index, 1);
            this.files.splice(index, 1);
            this.emitValues();
        },
        isValidFileUrl(url) {
            if (!url || typeof url !== "string") return false;
            const trimmed = url.trim();
            if (!trimmed || trimmed.endsWith("/")) return false;
            const pathPart = trimmed.split("?")[0].split("#")[0];
            const fileName = pathPart.split("/").filter(Boolean).pop() || "";
            if (!fileName || fileName === "form") return false;
            return true;
        },
        resolveFileUrl(uploadData, asset) {
            if (asset && this.isValidFileUrl(asset.cdnUrl)) {
                return asset.cdnUrl;
            }
            if (asset && asset._s3Key) {
                const s3Url = `https://static.supsis.live/${asset._s3Key}`;
                if (this.isValidFileUrl(s3Url)) {
                    return s3Url;
                }
            }
            const uploadPath = (uploadData && uploadData.path) || (asset && asset.path) || "";
            const filename = ((uploadData && uploadData.filename) || "").replace(/^\//, "");
            if (uploadPath && filename) {
                const normalizedPath = uploadPath.endsWith("/") ? uploadPath : uploadPath + "/";
                const constructed = `https://static.supsis.live/${normalizedPath}${filename}`;
                if (this.isValidFileUrl(constructed)) {
                    return constructed;
                }
            }
            if (asset && asset.path && asset._id && asset.ext) {
                const fallback = `https://static.supsis.live/${asset.path}${asset._id}.${asset.ext}`;
                if (this.isValidFileUrl(fallback)) {
                    return fallback;
                }
            }
            return null;
        },
        async uploadFile(file, index) {
            console.log("siteId:", this.siteId);
            if (!this.siteId) {
                console.error("siteId cannot be null");
                return;
            }
            const path = `${this.siteId}/form/`;
            try {
                const imdUploadData = await uploadAsset({
                    path,
                    name: file.name,
                    size: file.size,
                    type: "form",
                    mime: file.type,
                    ext: file.name.split(".").pop(),
                });

                await axios({
                    method: imdUploadData.data.method,
                    url: imdUploadData.data.url,
                    data: file,
                    headers: {
                        "Content-Type": "application/octet-stream",
                        "site-id": this.siteId,
                    },
                });

                const assetId = imdUploadData.data.asset._id;
                const asset = imdUploadData.data.asset;
                const fileUrl = this.resolveFileUrl(imdUploadData.data, asset);

                if (assetId && fileUrl) {
                    this.files[index]._id = assetId;
                    this.files[index].asset = asset; // Asset objesini de sakla
                    this.fileUrls.push(fileUrl);
                    this.emitValues();
                } else {
                    console.error("_id is null or file url is invalid.", fileUrl);
                }

            } catch (e) {
                console.error(e);
            }
        },
        emitValues() {
            const rawValues = Array.isArray(this.fileUrls) ?
                this.fileUrls :
                (this.fileUrls ? [this.fileUrls] : []);
            const values = rawValues.filter((url) => this.isValidFileUrl(url));

            this.$emit("input", {
                fieldId: this.fieldId,
                values: values
            });

            this.$emit("validate", {
                fieldId: this.fieldId,
                hasError: this.isRequired && this.files.length === 0,
            });
        },
        
        /**
         * FormContainer'dan mevcut form değerini alıp files listesini restore et
         */
        restoreFilesFromFormValue() {
            // Parent'tan mevcut form değerini al
            const formValue = this.$parent?.formValues?.[this.fieldId];
            
            if (formValue && formValue.values && Array.isArray(formValue.values) && formValue.values.length > 0) {
                const validUrls = formValue.values.filter((url) => this.isValidFileUrl(url));
                // Mevcut dosyaları files array'ine ekle
                this.files = validUrls.map((url, index) => ({
                    name: `Yüklenen Dosya ${index + 1}`,
                    preview: url,
                    url: url,
                    size: null, // Boyut bilgisi yok
                    raw: null   // Raw file yok (önceden yüklenmiş)
                }));
                
                // fileUrls'i de güncelle
                this.fileUrls = [...validUrls];
                
                console.log('🔴 Files restored from form value:', {
                    fieldId: this.fieldId,
                    fileCount: this.files.length,
                    urls: validUrls
                });
            } else {
                console.log('🔴 No existing files found for field:', this.fieldId);
            }
        },
    },
    beforeDestroy() {
        this.files.forEach(file => {
            URL.revokeObjectURL(file.preview);
        });
    },
    mounted() {
        const special = this.$route.query.special;
        if (special === "true") {
            this.isSpecial = true;
        }
        
        // Mevcut form değerini restore et
        this.restoreFilesFromFormValue();
        
        this.emitValues();
    },
};
</script>
<style lang="scss" scoped>
#file-upload {
    width: 100%;
    margin: 0 auto;
    font-family: var(--font-family);
}

// Align sistem - left
.file-align-left {
    display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);
    
    h3 {
        width: clamp(140px, 20vw, 200px);
        font-size: clamp(0.9rem, 2vw, 1rem);
        font-weight: 500;
        color: var(--text-primary);
        margin: 0;
        line-height: 1.5;
        flex-shrink: 0;
    }
    
    > div {
        flex: 1;
        min-width: 0;
    }
}

// Align sistem - right  
.file-align-right {
    display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);
    
    h3 {
        width: clamp(140px, 20vw, 200px);
        font-size: clamp(0.9rem, 2vw, 1rem);
        font-weight: 500;
        color: var(--text-primary);
        text-align: right;
        margin: 0;
        line-height: 1.5;
        flex-shrink: 0;
    }
    
    > div {
        flex: 1;
        min-width: 0;
    }
}

// Top align (default)
#file-upload:not(.file-align-left):not(.file-align-right) {
    h3 {
        font-size: clamp(0.9rem, 2vw, 1rem);
        font-weight: 500;
        color: var(--text-primary);
        margin: 0 0 clamp(0.75rem, 1.5vw, 0.875rem) 0;
        line-height: 1.5;
    }
}

// Upload container
    .upload-container {
    border: 2px dashed var(--border-color);
    border-radius: clamp(0.5rem, 1.5vw, 0.75rem);
    padding: clamp(1.5rem, 4vw, 2rem) clamp(1rem, 3vw, 1.5rem);
    background: var(--surface-color);
    backdrop-filter: blur(8px);
    transition: all 0.3s ease;
        position: relative;
    cursor: pointer;
    
    &:hover {
        border-color: var(--primary);
        background: var(--surface-hover);
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(99, 102, 241, 0.15);
    }
    
    &.error {
        border-color: var(--error);
        background: rgba(239, 68, 68, 0.05);
    }

        .file-input {
            display: none;
        }

        .file-label {
            display: flex;
            flex-direction: column;
            align-items: center;
        gap: clamp(0.75rem, 2vw, 1rem);
            cursor: pointer;

            .upload-icon {
            width: clamp(2.5rem, 6vw, 3rem);
            height: clamp(2.5rem, 6vw, 3rem);
            color: var(--primary);
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(99, 102, 241, 0.1);
            border-radius: 50%;
            transition: all 0.3s ease;
            
            svg {
                width: clamp(1.25rem, 3vw, 1.5rem);
                height: clamp(1.25rem, 3vw, 1.5rem);
            }
        }
        
        .upload-text {
            text-align: center;
            
            .upload-title {
                font-size: clamp(0.875rem, 2vw, 1rem);
                font-weight: 600;
                color: var(--text-primary);
                margin: 0 0 clamp(0.25rem, 0.5vw, 0.375rem) 0;
                line-height: 1.4;
            }
            
            .upload-subtitle {
                font-size: clamp(0.8rem, 1.8vw, 0.875rem);
                color: var(--text-secondary);
                margin: 0;
                line-height: 1.4;
            }
        }
    }
}

.upload-container:hover .upload-icon {
    background: rgba(99, 102, 241, 0.15);
    transform: scale(1.05);
}

// File list
    .file-list {
    margin-top: clamp(0.75rem, 2vw, 1rem);
    display: flex;
    flex-direction: column;
    gap: clamp(0.5rem, 1.2vw, 0.75rem);

        .file-item {
            display: flex;
            align-items: center;
        gap: clamp(0.5rem, 1.2vw, 0.75rem);
        padding: clamp(0.75rem, 2vw, 1rem);
        background: var(--surface-color);
        border: 1px solid var(--border-color);
        border-radius: clamp(0.375rem, 1vw, 0.5rem);
        transition: all 0.3s ease;
        
        &:hover {
            background: var(--surface-hover);
            border-color: var(--primary);
            transform: translateX(4px);
        }
        
        .file-preview-container {
            flex-shrink: 0;
            width: clamp(2.5rem, 6vw, 3rem);
            height: clamp(2.5rem, 6vw, 3rem);
            border-radius: clamp(0.375rem, 1vw, 0.5rem);
            overflow: hidden;
            background: var(--background);
            border: 1px solid var(--border-color);

            .file-preview {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.3s ease;
            }
        }
        
        .file-info {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            gap: clamp(0.125rem, 0.3vw, 0.25rem);

            .file-name {
                font-size: clamp(0.8rem, 1.8vw, 0.875rem);
                font-weight: 500;
                color: var(--text-primary);
                line-height: 1.4;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            
            .file-size {
                font-size: clamp(0.7rem, 1.5vw, 0.75rem);
                color: var(--text-secondary);
                line-height: 1.3;
            }
            }

            .delete-button {
            flex-shrink: 0;
            width: clamp(2rem, 4.5vw, 2.25rem);
            height: clamp(2rem, 4.5vw, 2.25rem);
                border: none;
            background: transparent;
            color: var(--text-secondary);
            border-radius: clamp(0.25rem, 0.6vw, 0.375rem);
                cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
            
            svg {
                width: clamp(1rem, 2.2vw, 1.125rem);
                height: clamp(1rem, 2.2vw, 1.125rem);
            }
            
            &:hover {
                background: rgba(239, 68, 68, 0.1);
                color: var(--error);
                transform: scale(1.1);
            }
        }
    }
}

.file-item:hover .file-preview {
    transform: scale(1.05);
}

// Special upload (korunuyor)
.special-upload {
    position: relative;
    display: inline-block;
    width: 200px;
    height: 100px;
    text-align: center;
    cursor: pointer;
    margin: -25px;
    margin-left: 50px;
}

.nano-img {
    width: 100%;
    height: 80px;
    display: block;
}

.label-overlay {
    position: absolute;
    top: 20%;
    left: 58%;
    transform: translate(-50%, -50%);
    color: black;
    font-weight: bold;
    text-align: center;
    font-family: sans-serif;
    margin-top: 16px;
    width: 150px;
    font-size: small;
}

// Mobil optimizasyonları
@media (max-width: 768px) {
    .file-align-left,
    .file-align-right {
        flex-direction: column;
        gap: 0;
        
        h3 {
            width: 100%;
            text-align: left !important;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        }
        
        > div {
            width: 100%;
        }
    }
    
    .upload-container {
        padding: clamp(1.25rem, 3vw, 1.5rem) clamp(0.75rem, 2vw, 1rem);
        
        .file-label {
            gap: clamp(0.625rem, 1.5vw, 0.75rem);
            
            .upload-icon {
                width: clamp(2.25rem, 5vw, 2.5rem);
                height: clamp(2.25rem, 5vw, 2.5rem);
                
                svg {
                    width: clamp(1.125rem, 2.5vw, 1.25rem);
                    height: clamp(1.125rem, 2.5vw, 1.25rem);
                }
            }
            
            .upload-text {
                .upload-title {
                    font-size: clamp(0.8rem, 1.8vw, 0.875rem);
                }
                
                .upload-subtitle {
                    font-size: clamp(0.75rem, 1.6vw, 0.8rem);
                }
            }
        }
    }
    
    .file-list {
        margin-top: clamp(0.625rem, 1.5vw, 0.75rem);
        gap: clamp(0.375rem, 1vw, 0.5rem);
        
        .file-item {
            padding: clamp(0.625rem, 1.5vw, 0.75rem);
            gap: clamp(0.375rem, 1vw, 0.5rem);
            
            .file-preview-container {
                width: clamp(2.25rem, 5vw, 2.5rem);
                height: clamp(2.25rem, 5vw, 2.5rem);
            }
            
            .file-info {
                .file-name {
                    font-size: clamp(0.75rem, 1.6vw, 0.8rem);
                }
                
                .file-size {
                    font-size: clamp(0.65rem, 1.4vw, 0.7rem);
                }
            }
            
            .delete-button {
                width: clamp(1.875rem, 4vw, 2rem);
                height: clamp(1.875rem, 4vw, 2rem);
                
                svg {
                    width: clamp(0.875rem, 2vw, 1rem);
                    height: clamp(0.875rem, 2vw, 1rem);
                }
            }
        }
    }
}

@media (max-width: 480px) {
    .file-align-left,
    .file-align-right {
        gap: 0;
        
        h3 {
            font-size: 0.875rem;
            margin-bottom: 0.5rem;
        }
    }
    
    #file-upload:not(.file-align-left):not(.file-align-right) {
        h3 {
            font-size: 0.875rem;
            margin-bottom: 0.625rem;
        }
    }
    
    .upload-container {
        padding: 1.25rem 0.75rem;
        border-radius: 0.5rem;
        
        .file-label {
            gap: 0.625rem;
            
            .upload-icon {
                width: 2.25rem;
                height: 2.25rem;
                
                svg {
                    width: 1.125rem;
                    height: 1.125rem;
                }
            }
            
            .upload-text {
                .upload-title {
                    font-size: 0.8rem;
                }
                
                .upload-subtitle {
                    font-size: 0.75rem;
                }
            }
        }
    }
    
    .file-list {
        margin-top: 0.625rem;
        gap: 0.375rem;
        
        .file-item {
            padding: 0.625rem;
            gap: 0.375rem;
            border-radius: 0.375rem;
            
            &:hover {
                transform: none;
            }
            
            .file-preview-container {
                width: 2.25rem;
                height: 2.25rem;
                border-radius: 0.375rem;
            }
            
            .file-info {
                gap: 0.125rem;
                
                .file-name {
                    font-size: 0.75rem;
                }
                
                .file-size {
                    font-size: 0.65rem;
                }
            }
            
            .delete-button {
                width: 1.875rem;
                height: 1.875rem;
                border-radius: 0.25rem;
                
                svg {
                    width: 0.875rem;
                    height: 0.875rem;
                }
                
                &:hover {
                    transform: scale(1.05);
                }
            }
        }
    }
}
</style>